// extracted by mini-css-extract-plugin
module.exports = {"url":"styles_url__I_QnX"};